import { cut } from "@/helper/getCut";

export function getUnique(list, key, isCut) {
	if (isCut) return cut(list.reduce((acc, item) => {
		const isExist = acc.some(body => body === item[key]);
		if (!isExist) {
			acc.push(item[key]);
		}
		return acc;
	}, []).length);
	return list.reduce((acc, item) => {
		const isExist = acc.some(body => body === item[key]);
		if (!isExist) {
			acc.push(item[key]);
		}
		return acc;
	}, []).length;
}
